// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_6yh","questions":"styles_questions__3vold","footer":"styles_footer__1HbOx"};